import { useQuery } from '@tanstack/react-query';

import appConfig from 'config';

import { api } from './base';

const getStrategicOutcomeCategories = async ({ countryCode, regionCode }) => {
	let apiUrl = appConfig.API_V2_URLS.GLOBAL_STRATEGIC_OUTCOME_CATEGORIES;

	if (countryCode) {
		apiUrl = `${appConfig.API_V2_URLS.COUNTRY_STRATEGIC_OUTCOME_CATEGORIES}${countryCode}/`;
	}

	if (regionCode) {
		apiUrl = `${appConfig.API_V2_URLS.REGION_STRATEGIC_OUTCOME_CATEGORIES}${regionCode}/`;
	}

	return api.get(apiUrl);
};

export const useStrategicOutcomeCategories = (
	{ countryCode, regionCode },
	options,
) =>
	useQuery({
		queryFn: () => getStrategicOutcomeCategories({ countryCode, regionCode }),
		...options,
	});
